import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-12 px-4" data-id="element-296">
      <div className="max-w-5xl mx-auto" data-id="element-297">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-298">
          <div data-id="element-299">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-300">
              +800
            </div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-301">
              docentes confían
            </div>
          </div>
          <div data-id="element-302">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-303">
              6+6
            </div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-304">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-305">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-306">
              4.9/5
            </div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-307">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-308">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-309">🇦🇷</div>
            <div className="text-[#39FF14] text-sm font-semibold mt-1" data-id="element-310">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-311">
          <div className="flex items-start gap-3 bg-black/40 border border-[#39FF14]/20 rounded-xl p-4" data-id="element-312">
            <div className="w-10 h-10 rounded-full bg-[#39FF14]/20 flex items-center justify-center text-[#39FF14] font-black text-sm flex-shrink-0" data-id="element-313">
              MG
            </div>
            <div data-id="element-314">
              <div className="text-[#39FF14] text-xs mb-1" data-id="element-315">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-316">
                "Organicé todo el año de Português en una tarde. Nunca más
                llegué sin material al aula."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-317">
                — Mariela G., Córdoba | Docente de Português
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#39FF14]/20 rounded-xl p-4" data-id="element-318">
            <div className="w-10 h-10 rounded-full bg-[#39FF14]/20 flex items-center justify-center text-[#39FF14] font-black text-sm flex-shrink-0" data-id="element-319">
              LP
            </div>
            <div data-id="element-320">
              <div className="text-[#39FF14] text-xs mb-1" data-id="element-321">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-322">
                "Las actividades están perfectamente pensadas para el alumno
                argentino. El solucionario me ahorra horas cada semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-323">
                — Laura P., Rosario | Docente de Português
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}